export function shouldSucceedWithProbability(probability: number) {
  return probability >= Math.random();
}

export function isEven(value: number) {
  return value % 2 === 0;
}
